var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticClass:"w-100 d-flex align-items-center d-flex justify-content-center",attrs:{"id":"small-loader"}},[_c('i',{staticClass:"far fa-spinner-third fa-spin fa-3x color-brand-primary"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }